// Detect if the current page is consider a public view
// Since logged in users can preview public content, the detection is based on the page path
import { useEffect, useRef } from 'react';
import { IS_EXTENSION } from '../constants/platform';

// For mocking
let isForcingPublic = false;
export const useForcePublicViewEffect = () => {
  const previousValue = useRef<boolean | undefined>(undefined);

  if (previousValue.current === undefined) {
    previousValue.current = isForcingPublic;
    isForcingPublic = true;
  }

  useEffect(
    () => () => {
      isForcingPublic = !!previousValue.current;
    },
    [],
  );
};

const REGEX = /^\/public\//i;
const useIsPublicView = () => {
  if (isForcingPublic) {
    return true;
  }
  return !IS_EXTENSION && REGEX.test(window.location.pathname);
};

export default useIsPublicView;
